import { create } from 'zustand';

const useStripeContributionDialogStore = create((set) => ({
  open: false,
  fundraisingOrg: null,
  amount: 0,
  post: null,
  setOpen: (
    isOpen,
    data = {
      fundraisingOrg: null,
      amount: '',
      post: null,
    },
  ) =>
    set(() => ({
      open: isOpen,
      fundraisingOrg: data.fundraisingOrg,
      amount: data.amount,
      post: data.post,
    })),
}));

export default useStripeContributionDialogStore;
